import DashboardPage from "./DashboardPage";
import CategoriesPage from "./CategoryListPage";
import BrandListPage from "./inventory/BrandListPage";
import UnitListPage from "./inventory/UnitListPage";
import WarehouseListPage from "./inventory/WarehouseListPage";
import StockLevelsPage from "./inventory/StockLevelsPage";
import StockAdjustmentPage from "./inventory/StockAdjustmentPage";
import StockMovementsPage from "./inventory/StockMovementsPage";
import StockTransferListPage from "./inventory/StockTransferListPage";
import NewStockTransferPage from "./inventory/NewStockTransferPage";
import ProductListPage from "./products/ProductListPage";
import ProductForm from "./products/ProductForm";
import ProfilePage from "./ProfilePage";
import SupplierListPage from "./supplier/SupplierListPage";
import SupplierDetailsPage from "./supplier/SupplierDetailsPage";
import InventoryPage from "./inventory/InventoryTransactionPage";
import PurchaseListPage from "./purchase/PurchaseListPage";
import PurchaseForm from "./purchase/PurchaseForm";
import CustomerListPage from "./CustomerListPage";
import SalesListPage from "./sales/SalesListPage";
import SalesForm from "./sales/SalesForm";
import SalesOrderDetailsPage from "./sales/SalesOrderDetailsPage";
import AdjustmentListPage from "./adjustment/AdjustmentListPage";
import AdjustmentForm from "./adjustment/AdjustmentForm";
import PurchaseOrderDetailsPage from "./purchase/PurchaseOrderDetailsPage";
import SupportRequestsPage from "./support/SupportRequestsPage";
import ReportsPage from "./ReportsPage";
import TeamManagementPage from "./team-management/TeamManagementPage";
import CreateEditUserPage from "./team-management/CreateEditUserPage";
import CreateEditRolePage from "./team-management/CreateEditRolePage";
import TenantDepartmentListPage from "./team-management/TenantDepartmentListPage";
import TenantDesignationListPage from "./team-management/TenantDesignationListPage";
import { Navigate } from "react-router-dom";
import SettingsProfilePage from "./settings/SettingsProfilePage";
import SettingsOrganizationPage from "./settings/SettingsOrganizationPage";
import SettingsPasswordPage from "./settings/SettingsPasswordPage";
import SettingsNotificationsPage from "./settings/SettingsNotificationsPage";
import SettingsBillingPage from "./settings/SettingsBillingPage";
import SettingsUsagePage from "./settings/SettingsUsagePage";

export interface AppRoute {
  path: string;
  element: React.ReactElement;
  allowedRoles?: string[];
}

export const appRoutes: AppRoute[] = [
  { path: "/dashboard", element: <DashboardPage /> },
  { path: "/product/list", element: <ProductListPage /> },
  { path: "/product/add", element: <ProductForm /> },
  { path: "/product/:productId/edit", element: <ProductForm /> },
  { path: "/profile", element: <ProfilePage /> },
  { path: "/settings", element: <Navigate to="/app/settings/profile" replace /> },
  { path: "/settings/profile", element: <SettingsProfilePage /> },
  { path: "/settings/organization", element: <SettingsOrganizationPage /> },
  { path: "/settings/password", element: <SettingsPasswordPage /> },
  { path: "/settings/notifications", element: <SettingsNotificationsPage /> },
  { path: "/settings/billing", element: <SettingsBillingPage /> },
  { path: "/settings/usage", element: <SettingsUsagePage /> },
  { path: "/category", element: <CategoriesPage /> },
  { path: "/brand", element: <BrandListPage /> },
  { path: "/unit", element: <UnitListPage /> },
  { path: "/warehouse", element: <WarehouseListPage /> },
  { path: "/stock/levels", element: <StockLevelsPage /> },
  { path: "/stock/adjust", element: <StockAdjustmentPage /> },
  { path: "/stock/movements", element: <StockMovementsPage /> },
  { path: "/stock/transfers", element: <StockTransferListPage /> },
  { path: "/stock/transfers/new", element: <NewStockTransferPage /> },
  { path: "/supplier/list", element: <SupplierListPage /> },
  { path: "/supplier/:supplierId", element: <SupplierDetailsPage /> },
  { path: "/inventory", element: <InventoryPage /> },
  { path: "/purchase/list", element: <PurchaseListPage /> },
  { path: "/purchase/create", element: <PurchaseForm /> },
  { path: "/purchase/:purchaseId/edit", element: <PurchaseForm /> },
  {
    path: "/purchase/:orderId",
    element: <PurchaseOrderDetailsPage />,
  },
  { path: "/customer/list", element: <CustomerListPage /> },
  { path: "/support", element: <SupportRequestsPage /> },
  { path: "/plan-usage", element: <Navigate to="/app/settings/billing" replace /> },
  { path: "/reports", element: <ReportsPage /> },
  { path: "/team-management", element: <TeamManagementPage /> },
  { path: "/team-management/user-list", element: <TeamManagementPage /> },
  { path: "/team-management/user/create", element: <CreateEditUserPage /> },
  {
    path: "/team-management/user/:tenantUserId/edit",
    element: <CreateEditUserPage />,
  },
  {
    path: "/team-management/role-list",
    element: <TenantDesignationListPage />,
  },
  { path: "/team-management/role/create", element: <CreateEditRolePage /> },
  {
    path: "/team-management/role/:tenantRoleId/edit",
    element: <CreateEditRolePage />,
  },
  {
    path: "/team-management/department-list",
    element: <TenantDepartmentListPage />,
  },
  { path: "/sale/list", element: <SalesListPage /> },
  { path: "/sale/create", element: <SalesForm /> },
  { path: "/sale/:saleId/edit", element: <SalesForm /> },
  { path: "/sale/:orderId", element: <SalesOrderDetailsPage /> },
  { path: "/adjustment/list", element: <AdjustmentListPage /> },
  { path: "/adjustment/create", element: <AdjustmentForm /> },
  { path: "/adjustment/:adjustmentId/edit", element: <AdjustmentForm /> },
  {
    path: "/notifications",
    element: <Navigate to="/app/settings/notifications" replace />,
  },
];
